import { PriceDetailMapper } from '../../../models/Price/PriceDetailMapper.js';
import { ProductsMapper } from '../../../models/Products/ProductsMapper.js';

class Products {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(shipments) {
    const payload = {
      shipments: shipments.map(shipment => {
        var _shipment$content, _shipment$upsales, _shipment$upsales$adu, _shipment$upsales2, _shipment$upsales2$ad, _shipment$upsales3, _shipment$upsales3$pr, _shipment$content2, _shipment$from, _shipment$from2, _shipment$from3, _shipment$from4, _shipment$from5, _shipment$upsales4, _shipment$upsales4$in, _shipment$parcels, _shipment$service, _shipment$to, _shipment$to2, _shipment$to3, _shipment$to4, _shipment$upsales5, _shipment$upsales5$ca;
        return {
          content_second_hand: (_shipment$content = shipment.content) === null || _shipment$content === void 0 ? void 0 : _shipment$content.secondHand,
          adult_signature: (_shipment$upsales = shipment.upsales) === null || _shipment$upsales === void 0 ? void 0 : (_shipment$upsales$adu = _shipment$upsales.adultSignature) === null || _shipment$upsales$adu === void 0 ? void 0 : _shipment$upsales$adu.available,
          additional_handling: (_shipment$upsales2 = shipment.upsales) === null || _shipment$upsales2 === void 0 ? void 0 : (_shipment$upsales2$ad = _shipment$upsales2.additionalHandling) === null || _shipment$upsales2$ad === void 0 ? void 0 : _shipment$upsales2$ad.available,
          proof_of_delivery: (_shipment$upsales3 = shipment.upsales) === null || _shipment$upsales3 === void 0 ? void 0 : (_shipment$upsales3$pr = _shipment$upsales3.proofOfDelivery) === null || _shipment$upsales3$pr === void 0 ? void 0 : _shipment$upsales3$pr.available,
          contentvalue: ((_shipment$content2 = shipment.content) === null || _shipment$content2 === void 0 ? void 0 : _shipment$content2.value) || 0,
          from: {
            city: (_shipment$from = shipment.from) === null || _shipment$from === void 0 ? void 0 : _shipment$from.city,
            country: (_shipment$from2 = shipment.from) === null || _shipment$from2 === void 0 ? void 0 : _shipment$from2.alpha2Code,
            state: (_shipment$from3 = shipment.from) === null || _shipment$from3 === void 0 ? void 0 : _shipment$from3.state,
            zip_code: (_shipment$from4 = shipment.from) === null || _shipment$from4 === void 0 ? void 0 : _shipment$from4.zipCode,
            street1: (_shipment$from5 = shipment.from) === null || _shipment$from5 === void 0 ? void 0 : _shipment$from5.street1
          },
          insurance: (_shipment$upsales4 = shipment.upsales) === null || _shipment$upsales4 === void 0 ? void 0 : (_shipment$upsales4$in = _shipment$upsales4.insurance) === null || _shipment$upsales4$in === void 0 ? void 0 : _shipment$upsales4$in.getUpdatePayload(),
          packages: (_shipment$parcels = shipment.parcels) === null || _shipment$parcels === void 0 ? void 0 : _shipment$parcels.map(parcel => {
            const {
              weight,
              width,
              height,
              length
            } = parcel.getCreatePayload();
            return {
              weight,
              width,
              height,
              length
            };
          }),
          packlink_reference: shipment.packlinkReference || undefined,
          service_id: (_shipment$service = shipment.service) === null || _shipment$service === void 0 ? void 0 : _shipment$service.id,
          source: shipment.source,
          to: {
            city: (_shipment$to = shipment.to) === null || _shipment$to === void 0 ? void 0 : _shipment$to.city,
            country: (_shipment$to2 = shipment.to) === null || _shipment$to2 === void 0 ? void 0 : _shipment$to2.alpha2Code,
            state: (_shipment$to3 = shipment.to) === null || _shipment$to3 === void 0 ? void 0 : _shipment$to3.state,
            zip_code: (_shipment$to4 = shipment.to) === null || _shipment$to4 === void 0 ? void 0 : _shipment$to4.zipCode
          },
          voucher_name: shipment.voucherName,
          cash_on_delivery_amount: (_shipment$upsales5 = shipment.upsales) === null || _shipment$upsales5 === void 0 ? void 0 : (_shipment$upsales5$ca = _shipment$upsales5.cashOnDelivery) === null || _shipment$upsales5$ca === void 0 ? void 0 : _shipment$upsales5$ca.amount
        };
      })
    };
    return this.apiClient.post('pro/shipments/products', payload).then(response => {
      var _response$data$summar, _response$data$summar2;
      return {
        summary: {
          total: PriceDetailMapper.createModelFromResponse(response.data.summary.total),
          products: {
            insurance: {
              ...PriceDetailMapper.createModelFromResponse(response.data.summary.products.insurance),
              protectionValue: (_response$data$summar = (_response$data$summar2 = response.data.summary.products.insurance) === null || _response$data$summar2 === void 0 ? void 0 : _response$data$summar2.protection_value) !== null && _response$data$summar !== void 0 ? _response$data$summar : 0
            },
            cashOnDelivery: PriceDetailMapper.createModelFromResponse(response.data.summary.products.cash_on_delivery),
            adultSignature: PriceDetailMapper.createModelFromResponse(response.data.summary.products.adult_signature),
            proofOfDelivery: PriceDetailMapper.createModelFromResponse(response.data.summary.products.proof_of_delivery),
            additionalHandling: PriceDetailMapper.createModelFromResponse(response.data.summary.products.additional_handling),
            porterage: PriceDetailMapper.createModelFromResponse(response.data.summary.products.porterage),
            voucher: PriceDetailMapper.createModelFromResponse(response.data.summary.products.voucher),
            managementFee: PriceDetailMapper.createModelFromResponse(response.data.summary.products.management_fee),
            priority: PriceDetailMapper.createModelFromResponse(response.data.summary.products.priority)
          }
        },
        productsDetails: response.data.products_details.map(productDetail => {
          return {
            packlinkReference: productDetail.packlink_reference,
            products: ProductsMapper.createModelFromResponse(productDetail.products)
          };
        })
      };
    });
  }
}

export { Products };
//# sourceMappingURL=Products.js.map
